<template>
  <span v-if="estateForDocument.name" class="caption font-weight-bold">
    {{ estateForDocument.name }} ({{ estateForDocument.socialSecurityNumber }})
  </span>
</template>
<script>
export default {
  props: {
    document: {
      type: Object,
      default: () => ({}),
    },

    estates: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    estateForDocument() {
      if ([
        'ESTATE_INVENTORY_DEED',
        'ESTATE_INVENTORY_DEED_ATTACHMENT',
        'ESTATE_INVENTORY_DEED_SHAREHOLDERS_CERTIFICATION',
      ].includes(this.document.documentType)) {
        return this.estates
          .find(estate => estate?.person.socialSecurityNumber
            === this.document.estateSocialSecurityNumber)?.person || {};
      }

      return {};
    },
  },
};
</script>
